import styled from 'styled-components'
import { Link } from 'react-router-dom'
import miniIcon from '../../assets/images/16@1x.png'
import logo from '../../assets/images/sprite-tto_v2.webp'

export const FooterWrap = styled.div`
    margin-top: 30px;

    @media screen and (max-width: 374px) {
        margin-top: 10px;
    }
`

export const FooterTop = styled.div`
    background-color: #eee;
    padding: 6px 0 1px 0;
`

export const FlexLayout = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const LogoList = styled.ul`
    list-style: none;
    display: flex;
`
export const LogoImage  = styled.img`
    
`


export const LogoItem = styled.li`
    &:nth-child(1) ${LogoImage} {
        width: 80px;
        height: 26px;
    }

    &:nth-child(2) ${LogoImage} {
        width: 51px;
        height: 18px;
        position: relative;
        top: 6px;
        margin-right: 10px;
    }

    &:nth-child(3) ${LogoImage} {
        width: 80px;
        height: 26px;
    }
`

export const LogoLink = styled(Link)`
    text-decoration: none;
    display: block;
`

export const Social = styled.div`
    display: flex;
    align-items: center;
`

export const SocialLabel = styled.p`
    color: #666;
    font-size: 13px;
    margin-right: 30px;
`

export const SocialIconList = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
`

export const SocialIconItemLink = styled(Link)`
    text-decoration: none;
`

export const SocialIconItem = styled.li`
    margin-right: 30px;

    &:nth-child(1) ${SocialIconItemLink} {
        background-image: url(${miniIcon});
        background-position: -5px -98px;
        display: block;
        width: 6px;
        height: 12px;
        background-repeat: no-repeat;
    }

    &:nth-child(2) ${SocialIconItemLink} {
        background-position: -2px -146px;
        display: block;
        width: 12px;
        height: 12px;
        background-image: url(${miniIcon});
        background-repeat: no-repeat;
    }

    &:nth-child(3) ${SocialIconItemLink} {
        background-position: -1px -114px;
        width: 14px;
        height: 12px;
        background-image: url(${miniIcon});
        display: block;
        background-repeat: no-repeat;
    }

    &:nth-child(4) ${SocialIconItemLink} {
        background-position: 0 -131px;
        width: 16px;
        height: 10px;
        background-image: url(${miniIcon});
        display: block;
        background-repeat: no-repeat;
    }
`

export const FooterMiddle = styled.div`
    background: #f4f4f4;
    padding-top: 12px;
`

export const FooterCategory = styled.ul`
    list-style: none;
    display: flex;
    width: 100%;
    flex-wrap: wrap;
`

export const FooterCategoryItem = styled.li`
    width: 181px;
`

export const FooterCategoryLink = styled(Link)`
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
    color: #666;
    display: block;
    opacity: .8;
    text-decoration: none;
    margin-bottom: 12px;
`

export const FootetBottom  = styled.div`
    background-color: #eee;
    padding: 19px 0;
`

export const FootetBottomLogoLink = styled(Link)`
    text-decoration: none;
    display: block;
    background-position: -5px -102px;
    width: 106px;
    height: 31px;
    background-image: url(${logo});
    background-repeat: no-repeat;
    background-size: 400px 300px;
`

export const FootetBottomText = styled.p`
    font-size: 13px;
    color: #222;
    width: 368px;
    margin-left: 28px;
    font-size: 13px;
    line-height: 1.4;
    color: #222;
    font-weight: bold;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        flex-direction: column;
        margin-left: 0;
        margin-top: 15px;
    }

    @media screen and (max-width: 767px) {
        margin-left: 0;
        margin-top: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #d1d1d1;
        font-weight: 400;
        width: auto;
    }
`

export const Information = styled.div`
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    @media screen and (max-width: 767px) {
        margin-left: 0;
        align-items: flex-start;
        margin-top: 8px;
        padding-bottom: 12px;
    }
`

export const InformationTitle = styled(Link)`
    color: #222;
    font-size: 13px;
    font-weight: 500;
    margin-top: 3px;
    text-decoration: none;

    @media screen and (max-width: 767px) {
        font-weight: 400;
    }
`

export const Title = styled.div`
    margin-bottom: 2px;
    line-height: 1;
`

export const InformationList = styled.ul`
    display: flex;
    list-style: none;
    padding-bottom: 10px;
    
    @media screen and (max-width: 374px) {
        flex-direction: column;
    }
`

export const InformationItem = styled.li`
    padding: 0 5px;

    &:not(:first-child) {
        border-left: 1px solid #666;
    }

    &:last-child {
        padding-right: 0;
    }

    @media screen and (max-width: 767px) {
        &:first-child {
            padding-left: 0;
        }
    }

    @media screen and (max-width: 374px) {
        flex-direction: column;
        padding: 2px 0;
        border: none !important;
    }
`

export const InformationLink = styled(Link)`
    text-decoration: none;
    display: block;
    color: #222;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;

    @media screen and (max-width: 767px) {
        font-weight: 400;
    }
`

export const FooterFlex = styled.div`
    display: flex;
    
    @media screen and (min-width: 768px) and (max-width: 1023px) {
        flex-direction: column;
    }

    @media screen and (max-width: 767px) {
        flex-direction: column;
    }
`

export const FooterBottomLayout = styled.div`
    display: flex;

    @media screen and (max-width: 767px) {
        flex-direction: column;
    }
`